"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Input = _interopRequireDefault(require("../Input/Input"));
var _withValidation = _interopRequireDefault(require("../../hocs/withValidation"));
var _excluded = ["className", "onValidate", "errors", "onBlur"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var StyledInput = (0, _styledComponents["default"])((0, _withValidation["default"])(_Input["default"])).withConfig({
  displayName: "InputWithErrorText__StyledInput",
  componentId: "sc-1d6q8fj-0"
})(["width:100%;"]);
var StyledInputWithError = _styledComponents["default"].div.withConfig({
  displayName: "InputWithErrorText__StyledInputWithError",
  componentId: "sc-1d6q8fj-1"
})(["position:relative;"]);
var ErrorMessage = _styledComponents["default"].div.withConfig({
  displayName: "InputWithErrorText__ErrorMessage",
  componentId: "sc-1d6q8fj-2"
})(["color:#D0021B;font-size:12px;line-height:16px;margin-top:2px;height:16px;"]);
var InputWithError = function InputWithError(_ref) {
  var className = _ref.className,
    onValidate = _ref.onValidate,
    errors = _ref.errors,
    onBlur = _ref.onBlur,
    inputProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(undefined),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isValid = _useState2[0],
    setValid = _useState2[1];
  var _useState3 = (0, _react.useState)(undefined),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    errMsg = _useState4[0],
    setErrMsg = _useState4[1];
  var isErrMsgEmpty = function isErrMsgEmpty(errMsg) {
    return !errMsg || errMsg === '\n';
  };
  var handleValidation = function handleValidation(flag) {
    setValid(flag);
    if (onValidate) {
      onValidate(flag);
    }
  };
  var validate = function validate(inputEl) {
    var validity = inputEl.validity;
    var valid = validity.valid,
      valueMissing = validity.valueMissing;
    var empty = errors.empty,
      invalid = errors.invalid;
    var message = null;
    if (!valid) {
      message = (valueMissing ? empty : invalid) || inputEl.validationMessage;
    }
    setErrMsg(message);
    return valid;
  };
  var handleOnBlur = function handleOnBlur(_ref2) {
    var target = _ref2.target;
    handleValidation(validate(target));
    onBlur();
  };
  var handleChange = function handleChange(_ref3) {
    var target = _ref3.target;
    var onChange = inputProps.onChange;
    var value = target.value;
    if (onChange) {
      onChange(value);
    }
  };
  return /*#__PURE__*/_react["default"].createElement(StyledInputWithError, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(StyledInput, (0, _extends2["default"])({}, inputProps, {
    onBlur: handleOnBlur,
    onChange: handleChange,
    isValid: isValid
  })), !isErrMsgEmpty(errMsg) && /*#__PURE__*/_react["default"].createElement(ErrorMessage, null, errMsg));
};
InputWithError.propTypes = {
  className: _propTypes["default"].string,
  errors: _propTypes["default"].shape({
    empty: _propTypes["default"].string,
    invalid: _propTypes["default"].string
  }),
  onValidate: _propTypes["default"].func,
  onBlur: _propTypes["default"].func
};
InputWithError.defaultProps = {
  className: '',
  errors: {},
  onValidate: null,
  onBlur: Function.prototype
};
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(InputWithError);